var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"translate",rawName:"v-translate"}],class:_vm.applyBtnClasses,attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.stopPropagation();_vm.handleApplyBtnClick()}}},[_vm._v("\n  Apply\n")])}
var staticRenderFns = []

export { render, staticRenderFns }